import React, { useMemo } from 'react'
import { useStyles } from './LogoAvailabilityForm.styles'
import { Typography } from '@mui/material'
import {
  RadioButtonGroupMapping,
  RadioButtonsV2,
  RadioButtonType,
} from '@labrav/react-components'
import clsx from 'clsx'
import { useFormikContext } from 'formik'
import {
  awsBlackLogo,
  awsWhiteLogo,
} from '../../../../../../common/utils/constants'
import { useStyles as commonStyles } from '../../../../FlyOutStorefront.styles'
import { ListingCardInCreation } from '../../../../../../modules/storefront/listingCardCreation/reducer'

export const LogoAvailability: React.FC = () => {
  const { classes } = useStyles()
  const { classes: commonClasses } = commonStyles()

  const { values, setFieldValue } = useFormikContext<ListingCardInCreation>()
  const { listingCardData } = values

  const logoOptions: RadioButtonGroupMapping[] = [
    {
      key: 'Black',
      label: 'Black',
      type: RadioButtonType.STANDARD,
      disabled: false,
    },
    {
      key: 'White',
      label: 'White (On dark backgrounds)',
      type: RadioButtonType.STANDARD,
      disabled: false,
    },
  ]
  const checkedValue = useMemo(() => {
    return listingCardData?.template?.data?.buyWithAwsLogoUrl === awsWhiteLogo
      ? 'White'
      : 'Black'
  }, [listingCardData?.template?.data?.buyWithAwsLogoUrl])

  const handleSelection = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValue = (event.target as HTMLInputElement).value
    const url = selectedValue === 'White' ? awsWhiteLogo : awsBlackLogo

    await setFieldValue('listingCardData.template.data.buyWithAwsLogoUrl', url)
  }

  return (
    <>
      <div
        className={clsx(
          classes.container,
          classes.sectionWrapper,
          classes.content,
          classes.root
        )}
        data-testid="card-container"
      >
        <Typography data-testid="header-title" className={classes.headerTitle}>
          Available in AWS Marketplace logo
        </Typography>
        <Typography
          data-testid="section-title"
          className={classes.sectionTitle}
        >
          If single card, this will be in the card. If multiple cards this will
          be on top of the layout with description.
        </Typography>

        <div className={classes.radioWidth}>
          <RadioButtonsV2
            name={'listingCardData.template.data.buyWithAwsLogoUrl'}
            handleChange={handleSelection}
            checkedValue={{
              key: checkedValue,
              value: checkedValue,
            }}
            radioButtonMappings={logoOptions}
          />
        </div>
      </div>
    </>
  )
}
